import { FunctionComponent } from 'react'
import { Box } from '@mui/material';

export const ImageDisplay: FunctionComponent<{
  url: string | undefined,
  customHeight?: string,
  customWidth?: string,
  alt?: string
}> = ({
  url,
  customHeight = '48px',
  customWidth = '200px',
  alt = 'Logo'
}) => {
    return (
      <Box sx={{ height: customHeight, maxWidth: customWidth, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <img style={{ maxWidth: "100%", maxHeight: "100%", objectFit: 'cover'}} src={url} alt={alt} />
      </Box>
    )
  }